import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import generalActions from 'redux/actions/generalActions'
import quickLaunchActions from 'redux/actions/quickLaunchActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import TimerModal from 'views/modals/timer_modal'

class QuickLaunchTimerCreateModalContainer extends PureComponent {

	closeModalHandler = () => {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<TimerModal
				title={localize('quick_launch_timer_title')}
				saveButtonLabel={localize('quicklaunch')}
				saveHandler={this.props.actions.save}
				cancelHandler={this.props.actions.cancel}
				closeModalHandler={this.closeModalHandler}
			/>
		)
	}

}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		save: quickLaunchActions.timerCreateSave,
		cancel: quickLaunchActions.timerCreateCancel,
	}, dispatch)
}

QuickLaunchTimerCreateModalContainer.propTypes = {
	modalName: PropTypes.string.isRequired,
	actions: PropTypes.shape({
		closeModal: PropTypes.func.isRequired,
		save: PropTypes.func.isRequired,
		cancel: PropTypes.func.isRequired,
	}),
}

export default connect(null, mapDispatchToProps)(
	QuickLaunchTimerCreateModalContainer
)

export { QuickLaunchTimerCreateModalContainer }
